import { Schema } from '../../schema'
import { Variables } from './api'

export const mapper = (data: Schema): Variables => ({ ...data })
